<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'app',
    data () {
        return {
            isOffline: false
        }
    },
    created () {
    },
    methods: {
    }
}
</script>

<style lang="less">
#app {
    font-family: 'PingFangSC-Medium' ,'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100vh;
    background-color: rgba(0,0,0,0.6);
    position: relative;
}
</style>
